import React from "react";
import { Dropdown } from "rsuite";
import styled from "styled-components";

interface MenuItemProps {
  id?: string;
  action: () => void;
  label: string;
  type?: "default" | "danger";
}

const Container = styled(Dropdown.Item)`
  text-align: left;
  padding: 4px 25px !important;
  color: var(--color-black) !important;
  font-size: 15px;

  &:hover {
    color: ${(props) =>
      props.type === "danger"
        ? "#fff !important"
        : "var(--color-white) !important"};
    background-color: ${(props) =>
      props.type === "danger" ? "var(--color-dark-red)" : "var(--color-black)"};
  }
`;

export default function MenuItem({
  id = "",
  action,
  label,
  type = "default",
}: MenuItemProps) {
  return (
    <Container id={id} type={type} key={1} onClick={action}>
      {label}
    </Container>
  );
}
